import AddPlaceModal from './AddPlaceModal';
import ContentSearchPage from '../ContentSearchPage';

const options = {
  pageTitle: 'City Guide',
  contentType: 'place',
  pageIcon: 'building outline',
  addItemModal: <AddPlaceModal />,
};

const CityGuidePage = () => <ContentSearchPage {...options} />;

export default CityGuidePage;
